/* ============================================================
   assets/int-founders-band.js               INTENTION — 2026-09-03
   Makes the Meet the Founders band tappable. Styling is
   assets/int-founders-band.css — read that header first.

   ⚑ THERE IS NO LINK, AND THAT IS DELIBERATE — 2026-09-03. The first version
   wrapped the block in an <a> to /pages/about and gave it the pairing band's
   arrow. Nils: "The Meet the founders section is a 'headline' to the video
   below. So the arrow link will mislead."

   He is right: the band introduces the founder video that follows it on the
   page, so an arrow pointing away from that video sends the reader somewhere
   else at exactly the moment they were about to watch it. The band is a
   heading, so it behaves like one.

   ⚑ THIS FILE IS NOW ONLY A TEARDOWN. It exists to remove the link a cached
   page or an older asset may still have applied, and to keep one obvious
   place to look for anything the band needs later. Do not re-add an outbound
   link here without dealing with the video below it first.
   ============================================================ */
(function () {
  'use strict';
  if (window.__intFoundersBand) return;
  window.__intFoundersBand = true;

  function mount() {
    if (!document.body.classList.contains('template-product')) return;

    var sec = document.querySelector('[id*="section_gallery_text_"]');
    if (!sec) return;

    /* unwrap the link, if an earlier version of this file put one there */
    var a = sec.querySelector('.int-founders-link');
    if (a && a.parentNode) {
      while (a.firstChild) a.parentNode.insertBefore(a.firstChild, a);
      a.parentNode.removeChild(a);
    }
    var arrow = sec.querySelector('.int-founders-arrow');
    if (arrow && arrow.parentNode) arrow.parentNode.removeChild(arrow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
